import { Flex, Text } from "@chakra-ui/react"
import { Button, Heading } from "DesignSystem/components"
import React from "react"

export type BoostingCardProps = {
  title: string
  description: string
  primaryActionText: string
  secondaryActionText: string
  primaryAction: () => void
  secondaryAction: () => void
}

export const BoostingCard: React.FC<BoostingCardProps> = ({
  title,
  description,
  primaryActionText,
  secondaryActionText,
  primaryAction,
  secondaryAction,
}) => {
  return (
    <Flex
      flexDirection="column"
      gap={4}
      bg="ds.surface.raised.resting"
      boxShadow="ds.raised"
      py={4}
      ps={3}
      pe={4}
      rounded="12px"
    >
      <Flex flexDirection="column" gap={2}>
        <Heading as="h3" textStyle="ds.heading.tertiary">
          {title}
        </Heading>
        <Text textStyle="ds.paragraph.secondary">{description}</Text>
      </Flex>
      <Flex gap={2}>
        <Button size="compact" onClick={primaryAction}>
          {primaryActionText}
        </Button>
        <Button size="compact" variant="subtle" onClick={secondaryAction}>
          {secondaryActionText}
        </Button>
      </Flex>
    </Flex>
  )
}
